import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.jsx'

// Helper function for React Snap
const rootElement = document.getElementById('root');

// Check if the app is being pre-rendered with react-snap
const isSnapRender = window.location.search.includes('snapshot');

if (rootElement.hasChildNodes() || isSnapRender) {
  // Hydrate for React Snap
  createRoot(rootElement).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
} else {
  // Normal render for browser
  createRoot(rootElement).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}
